import {createLocalStorageManager} from '../../utils/storage';

export const devDataStorage = createLocalStorageManager<{
  apiUrlNew: string,
}>('devData');
